// import { baseURL } from '@/config'
const baseURL = window.baseURL
const UIMSUrl = baseURL.Gateway + 'uims/api/'
const SalesUrl = baseURL.Gateway + 'sales/api/'
const FileServer = baseURL.Gateway + 'fileserver/api/'
const FileHost = baseURL.FileHost
const SurveyUrl = baseURL.Gateway + 'survey/api/'
const CRMUrl = baseURL.Gateway + 'crm/api/'
const ManagerUrl = baseURL.Gateway + 'manager/api/'
const ServiceUrl = baseURL.Gateway + 'service/api/'

const api = {}

api.defaultTenant = 'zeyu'
api.H5Host = baseURL.H5Host

api.UploadImage = FileServer + 'File/UploadImage'
api.UploadVideo = FileServer + 'File/UploadVideo'
api.UploadAudio = FileServer + 'File/UploadAudio'
api.UploadFile = FileServer + 'File/UploadAttachment'
const LogUrl = baseURL.Gateway + 'log/api/'

api.FileHost = FileHost
// namespaced: user
api.GetTenantByCode = UIMSUrl + 'Tenant/GetTenantByCode'
api.login = UIMSUrl + 'User/Login'
api.GetUserInfo = UIMSUrl + 'User/GetUserInfo'
api.GetCurrentUserInfo = UIMSUrl + 'User/GetCurrentUserInfo'
api.GetUserInfoByAccount = UIMSUrl + 'User/GetUserInfoByAccount' //根据account 查找用户
// namespaced: user
api.WechatGetOpenAppID = UIMSUrl + 'Wechat/GetOpenAppID'
api.WechatLogin = UIMSUrl + 'Wechat/Login'

api.UserAddByWX = UIMSUrl + 'User/AddByWX' //添加一个微信 unionId 用户
api.UserWxLogin = UIMSUrl + 'User/WxLogin' //用微信ID登录
api.WechatGetJSSdkInfo = UIMSUrl + 'Wechat/GetJSSdkInfo'
// api.StaffRegister = UIMSUrl + 'Staff/Register' // 注册用户绑定租户
// api.StaffDeregister = UIMSUrl + 'Staff/Deregister' // 注册用户解绑租户
// api.QueryStaffList = UIMSUrl + 'Staff/QueryStaffList' // 租户下用户列表
// api.StaffRoleGetRightList = SalesUrl + 'StaffRole/GetRightList' // 查找租户下用户列表对应的role
api.UserRegister = UIMSUrl + 'User/Register' // 注册用户
api.UserUpdateAvatar = UIMSUrl + 'User/UpdateAvatar' // 更新用户头像
api.UserUpdateUserInfo = UIMSUrl + 'User/UpdateUserInfo'
api.VerfiyAccount4SendVerificationCode =
  UIMSUrl + 'User/VerfiyAccount4SendVerificationCode'
api.ResetPassword = UIMSUrl + 'User/ResetPassword'
api.SendVerificationCode = UIMSUrl + 'Verification/SendVerificationCode'
api.VerificateCode = UIMSUrl + 'Verification/VerificateCode'
api.GetProvinceCityTree = UIMSUrl + 'Area/GetProvinceCityTree'

api.LogAppend = LogUrl + 'Log/Append'
api.LogQuery = LogUrl + 'Log/Query'

api.WechatGetAppID = UIMSUrl + 'Wechat/GetAppID'
api.WechatAuthor = UIMSUrl + 'Wechat/Author'

api.SurveyGetDetails = SurveyUrl + 'Survey/GetDetails' // 查询问卷下的所有题干
api.SurveyGetDetailsV2 = SurveyUrl + 'Survey/GetDetailsV2' // 查询问卷下的所有题干(通过分发查询)
api.SurveyResultStart = SurveyUrl + 'SurveyResult/Start' //开始答题
api.SurveyResultComplete = SurveyUrl + 'SurveyResult/CompleteV2' //结束答题
api.SurveyAnswerAdd = SurveyUrl + 'SurveyAnswer/Answer' //答题
api.SurveyAnswerAnswerList = SurveyUrl + 'SurveyAnswer/AnswerList' //答题
api.SurveyAnswerModify = SurveyUrl + 'SurveyAnswer/Modify' // 修改答案
api.FormQueryFormSurvey = SalesUrl + 'Form/QueryFormSurvey' //查询工单对应的答卷详情
api.SurveyResultGetListByUser = SurveyUrl + 'SurveyResult/GetListByUser' // 获取用户填写过的问卷
api.SurveyResultGetListByUserId = SurveyUrl + 'SurveyResult/GetListByUserId'
api.ProductAgreementGet = SalesUrl + 'ProductAgreement/Get'
api.GetUserResult = SurveyUrl + 'SurveyResult/GetUserResult'
// 测评
api.AssessmentGetDetailById = SurveyUrl + 'Assessment/GetDetailById'
api.AssessmentAnswer = SurveyUrl + 'Assessment/AssessmentAnswerV2'

// SalesUrl
api.WorkflowStart = SalesUrl + 'Workflow/Start'
api.WorkflowAdvancedApply = SalesUrl + 'Workflow/AdvancedApply' //二次咨询单
api.WorkflowAgreement = SalesUrl + 'Workflow/AgreementV2' // 用户签署协议
api.BindFastDealFormByActiveLink =
  SalesUrl + 'Workflow/BindFastDealFormByActiveLink' //直接成交单激活链接绑定
api.GetByDispatchIds = SalesUrl + 'SurveyDispatch/GetByDispatchIds' // 获取分发外链问卷详情

api.IndustryGetAll = UIMSUrl + 'Industry/GetAll' //获取所有有效的行业定义
api.DictionaryGetAll = UIMSUrl + 'Dictionary/GetAll' // 获取所有字典项

// crm
api.GetCollectInfoTemplate = CRMUrl + 'CustExtTemplate/GetCollectInfoTemplate'
api.CustomerExtensionBatchSave = CRMUrl + 'CustomerExtension/BatchSave'
api.GetInfoCollection = CRMUrl + 'InfoCollectionConfig/GetInfoCollection'
api.SaveInfoCollection = CRMUrl + 'InfoCollectionConfig/SaveInfoCollection'

api.GetAgreementInfo = ManagerUrl + 'SettingCenter/GetAgreementInfo'
api.ConsultationSheetSubmitCallback =
  ServiceUrl + 'Delivery/ConsultationSheetSubmitCallback'

//Workflow/BindFastDealFormByActiveLink

export default api
